import { createContext, useContext, useState, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

// Contexts
import { useAuthInfo } from '@propelauth/react'

const SectionTabContext = createContext([])

export function SectionTabProvider({ children }) {
    // const [sections, setSections] = useState([])
    const [sectionInfo, setSectionInfo] = useState([])
    const [selectedSection, setSelectedSection] = useState(null)
    const authInfo = useAuthInfo()
    const orgId = authInfo.orgId

    // useEffect(() => {
    //     setSections(generateDefaultSections(orgId))
    // }, [])

    return (
        <SectionTabContext.Provider value={{ sectionInfo, setSectionInfo, selectedSection, setSelectedSection }}>
            {children}
        </SectionTabContext.Provider>
    )
}

export function useSectionTab() {
    return useContext(SectionTabContext)
}